import Catalog from './catalog';
import Guess from './guess';

const routes = [
  {
    path: '/',
    component: Catalog,
  }, {
    path: '/:artist',
    component: Guess,
  }
]

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js